<div class="notice-popup-header">
  <h1 mat-dialog-title class="notice-popup-title" data-testid="system-notice-popup-title">{{ data.notice.Title }}</h1>

  <button type="button"
          class="notice-popup-close"
          aria-label="Dismiss notice"
          data-testid="system-notice-popup-dismiss"
          (click)="close()">
    <i class="icon-x icon-text-blue"></i>
  </button>
</div>

<mat-dialog-content class="dialog-scroll-shadow">
  @if (imageUrl && !imageFailed) {
    <img class="notice-popup-image"
         [src]="imageUrl"
         alt=""
         loading="lazy"
         (error)="imageFailed = true" />
  }

  <div class="notice-popup-description" data-testid="system-notice-popup-description">{{ data.notice.Description }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button"
          class="btn btn-secondary"
          data-testid="system-notice-popup-dismiss-button"
          (click)="close()"
          rtI18n>Dismiss</button>

  @if (data.notice.MoreInfo) {
    <button type="button"
            class="btn btn-primary"
            data-testid="system-notice-popup-more-info"
            (click)="data.onMoreInfo()"
            rtI18n>More Info</button>
  }
</mat-dialog-actions>
